import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { withRouter, RouteComponentProps } from 'react-router'

import { IWithAuthStatus, IWithTrigger, withAuthStatus, withTrigger } from '../../data/ApiProvider'
import styled from '../../styledComponents'
import { ACol } from '../../components/atoms/index'
import OTopBar, { IMenuItem } from '../../components/organisms/OTopBar'
import OLeftMenu, { ILeftMenuItem } from '../../components/organisms/OLeftMenu'
import { IFooterLink } from '../../components/organisms/OFooter'
import Eula from '../../containers/auth/Eula'

const Background = styled.div`
    min-height: 100vh;
    background-color: ${props => props.theme.colorBackground};
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: 100%;
    display: flex;
    flex-direction: column;
`

const ContentLayout = styled.div`
    display: flex;
    flex-direction: row;
    flex: auto;
    min-height: 0;
`

const PageContent = styled.div`
    flex: auto;
    min-height: 0;
    padding: 2rem;
    overflow-x: hidden;
    margin-top: 60px;
`

const getFooterLinks = (trigger: (name: string) => void): Array<IFooterLink> => [
    {
        url: '/content/about',
        name: <FormattedMessage id="common.about" defaultMessage="About" />,
        type: 'company',
    },
    {
        url: '/content/careers',
        name: <FormattedMessage id="common.careers" defaultMessage="Careers" />,
        type: 'company',
    },
    {
        url: 'mailto:info@bravua-ai.com',
        name: <FormattedMessage id="common.contact" defaultMessage="Contact" />,
        type: 'company',
        onClick: () => trigger('contact'),
    },
    {
        url: 'mailto:support@centreblock.net',
        name: <FormattedMessage id="common.supportCenter" defaultMessage="Support Center" />,
        type: 'support',
        onClick: () => trigger('support_center'),
    },
    {
        url: 'mailto:support@centreblock.net',
        name: <FormattedMessage id="common.helpDesk" defaultMessage="Helpdesk" />,
        type: 'support',
        onClick: () => trigger('helpdesk'),
    },
    {
        url: '/content/faq',
        name: <FormattedMessage id="common.faq" defaultMessage="FAQ" />,
        type: 'support',
    },
]

const getActiveStatus = (url: string, currentPath: string): boolean => currentPath.includes(url)
const customerAdminMenuLinks = (): Array<ILeftMenuItem> => 
    [
        {
            link: `/customer/reporting`,
            icon: 'reports',
            message: <FormattedMessage id="menu.reporting" defaultMessage="Reports" />,
            active: true
        }
    ]

const getRoleMenuLinks = (currentPath: string, isAdmin: boolean, isReportsAdmin: boolean): Array<ILeftMenuItem> =>
    isAdmin
        ? [
              {
                  link: `/admin/customers`,
                  icon: 'user2',
                  message: <FormattedMessage id="menu.customers" defaultMessage="Customers" />,
              },
              {
                  link: `/admin/settings`,
                  icon: 'settings',
                  message: <FormattedMessage id="menu.settings" defaultMessage="Settings" />,
              },
          ]
        : isReportsAdmin? 
        [
            {
                link: `/customer/reporting`,
                icon: 'reports',
                message: <FormattedMessage id="menu.developer" defaultMessage="Reports" />,
            },
        ]
        :[
              {
                  link: `/customer/dashboard`,
                  icon: 'dashboard',
                  message: <FormattedMessage id="menu.dashboard" defaultMessage="Dashboard" />,
              },
              {
                  link: `/customer/reporting`,
                  icon: 'reports',
                  message: <FormattedMessage id="menu.reporting" defaultMessage="Reports" />,
              },
              
            {
                link: `/customer/reportusers`,
                icon: 'reports',
                message: <FormattedMessage id="menu.developer" defaultMessage="Users" />,
            },
          ]

const getMenuLinks = (currentPath: string, isAdmin: boolean): Array<IMenuItem> =>
    [].map(item => ({
        ...item,
        active: getActiveStatus(item.link, currentPath),
    }))

const getLeftMenuLinks = (currentPath: string, isAdmin: boolean, isReportsAdmin: boolean): Array<ILeftMenuItem> =>
    [...getRoleMenuLinks(currentPath, isAdmin, isReportsAdmin)].map(item => ({
        ...item,
        active: getActiveStatus(item.link, currentPath),
    }))

const getCustomerAdminLeftMenuLinks = (currentPath: string): Array<ILeftMenuItem> =>
    [...customerAdminMenuLinks()].map(item => ({
        ...item,
        active: true,
    }))
class PageWrapper extends React.Component<IWithAuthStatus & IWithTrigger & RouteComponentProps> {
   
    render() {
        const { location } = this.props
        const { loggedIn, isAdmin, isEulaAccepted , eula, report, isReportsAdmin} = this.props.auth
        const isReportsUser = localStorage.getItem('isReportsAdmin')
        const menuLinks = getMenuLinks(location.pathname, isAdmin)
        const leftMenuLinks = getLeftMenuLinks(location.pathname, isAdmin,isReportsAdmin)
        const customerAdminMenuLinks = getCustomerAdminLeftMenuLinks(location.pathname)
        // const footerLinks = getFooterLinks(this.props.trigger)
        // if not logged in
        if (!loggedIn) {
            return (
                <Background>
                    <ContentLayout style={{ backgroundColor: '#F7F7F7' }}>
                        <PageContent>{this.props.children}</PageContent>
                    </ContentLayout>
                </Background>
            )
        } else if (loggedIn && !isEulaAccepted) {
            return (
                <Background>
                    <Eula eula={eula}></Eula>
                </Background>
            )
        } else if (loggedIn && (isReportsUser ==='true') ) {
            return (
                <Background>
                <OTopBar menuItems={loggedIn ? menuLinks : []} />
                <ContentLayout style={{ backgroundColor: '#F7F7F7' }}>
                    <ACol sm={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <OLeftMenu menuItems={customerAdminMenuLinks} />
                    </ACol>
                    <ACol sm={10}>
                        <PageContent>{this.props.children}</PageContent>
                    </ACol>
                </ContentLayout>
            </Background>
            )
        }
         else {
            // if logged in
            return (
                <Background>
                    <OTopBar menuItems={loggedIn ? menuLinks : []} />
                    <ContentLayout style={{ backgroundColor: '#F7F7F7' }}>
                        <ACol sm={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <OLeftMenu menuItems={leftMenuLinks} />
                        </ACol>
                        <ACol sm={10}>
                            <PageContent>{this.props.children}</PageContent>
                        </ACol>
                    </ContentLayout>
                </Background>
            )
        }
    }
}

export default withTrigger(withAuthStatus(withRouter(PageWrapper)))
